import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { EigentumanteilMasterDetailVM, EigentumViewmodelService } from '../../../core/services/eigentum-viewmodel.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { GbgrundstueckService } from '../../../core/gb-api';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { ListLoaderInfiniteBuilder } from '../../../shared/components/list-loader/list-loader-infinite';
import { map, tap } from 'rxjs/operators';
import { LoadingState } from '../../../shared/components/list-loader/loading-state';
import { NavTarget } from '../../../shared/components/link/link.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { MapsComponent } from '../../../shared/widgets/maps/maps.component';
import { NgClass } from '@angular/common';
import { EigentumTableComponent } from '../../../shared/widgets/eigentum-table/eigentum-table.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-eigentum-rubrik',
  templateUrl: './grundstueck-eigentum-rubrik.component.html',
  styleUrls: ['./grundstueck-eigentum-rubrik.component.scss'],
  imports: [RubrikComponent, MapsComponent, NgClass, EigentumTableComponent, TranslatePipe]
})
export class GrundstueckEigentumRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  listLoader: ListLoader<EigentumanteilMasterDetailVM>;
  ersterfassungUebergeben: boolean;

  mapAvailable = false;

  eigentumErweitert = false;
  private readonly PAGE_SIZE: number = undefined;
  private readonly CHUNK_SIZE: number = 5;
  private readonly CHUNK_SIZE_ERWEITERTES_EIGENTUM: number = 5;

  navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK;

  constructor(
    private eingtumViewModelService: EigentumViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  enableEigentumErweitert(): void {
    this.eigentumErweitert = true;
    this.loadData();
  }

  disableEigentumErweitert(): void {
    this.eigentumErweitert = false;
    this.loadData();
  }

  isMapsMenuDisabled(): boolean {
    return !this.mapAvailable;
  }

  protected loadData(): void {
    this.listLoader = this.createEigentumLoader();
    this.listLoader.state$.subscribe((state) => {
      if (state === LoadingState.ALL_DATA_LOADED) {
        this.mapAvailable = this.listLoader.items.some((element) => element.berechtigtesGrundstueckVm != null);
      }
    });
  }

  private createEigentumLoader(): ListLoader<EigentumanteilMasterDetailVM> {
    const observable = (offset, limit) => {
      return this.eingtumViewModelService
        .loadSichtByGrundstueckId(this.gsId, this.eigentumErweitert, true, true, offset, limit, this.subscriptions)
        .pipe(
          tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
          map((res) => res.entries)
        );
    };

    const loader = ListLoaderInfiniteBuilder.builder<EigentumanteilMasterDetailVM>()
      .setLookupItemFunc(observable)
      .setCurrentPage(1)
      .setPageSize(this.PAGE_SIZE)
      .setChunkSize(this.eigentumErweitert ? this.CHUNK_SIZE_ERWEITERTES_EIGENTUM : this.CHUNK_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
